import { call } from "./api";

export const count = params => {
    return call(client => {
        return client.get(`/contents/count`, params);
    });
};

export const all = () => {
    return call(client => {
        return client.get(`/contents`, {
            params: { count: 0 }
        });
    });
};

export const search = params => {
    return call(client => {
        return client.get(`/contents`, params);
    });
};

export const searchByUser = params => {
    return call(client => {
        return client.get(`/users/contents/all`, params);
    });
};

export const add = params => {
    return call(client => {
        return client.post(`/contents`, params);
    });
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/contents/${id}`, params);
    });
};

export const remove = (id, params) => {
    return call(client => {
        return client.delete(`/contents/${id}`, params);
    });
};

export const batchRemove = (ids, params) => {
    const promises = ids.map(id => {
        return call(client => {
            return client.delete(`/contents/${id}`, params);
        });
    });

    return Promise.all(promises);
};

/**
// views
export const view = (params) => {
    return call(client => {
        return client.get(`/views`, params);
    });
};

export const csv = (params) => {
    return call(client => {
        return client.get(`/views/csv`, params);
    });
};
**/
export const addView = (params) => {
    return call(client => {
        return client.get(`/users/contents/${params.params.contentId}/view`, params);
    });
};

export function searchAvailable(params) {
    return call(client => {
        return client.get(`/contents/available`, params)
    });
}



// WEBPACK FOOTER //
// ./src/api/content.js